module.exports = "pegasus/assets/email1-header-1.png";